<template>
  <div class>
    <div class="clearFix top-btn-box">
      <router-link class="floatl" to="/pc/product">＜＜ 去添加商品</router-link>
      <div class="floatr">
        <el-button type="primary" plain @click="clearGoods">清空购物车</el-button>
        <el-button type="primary" @click="confirmGoods">结算</el-button>
      </div>
    </div>
    <div style="height: 25px;">
      <h4 style="margin-left: 33%;color: red;">部分耗材、试剂类产品邮费另算，具体邮费金额请联系业务员</h4>
    </div>
    <el-table
      class="goods-table"
      @select-all="seletAll"
      @select="selectChange"
      type="index"
      max-height="400"
      ref="multipleTable"
      :data="goodsTable"
      tooltip-effect="dark"
      style="width: 100%"
    >
      <el-table-column type="selection" width="50"></el-table-column>
      <el-table-column
        prop="productName"
        label="产品名称"
        show-overflow-tooltip
        width="120"
        align="center"
      ></el-table-column>
      <el-table-column prop="orderNo" label="产品编号" show-overflow-tooltip width="110" align="center"></el-table-column>
      <el-table-column prop="specifications" label="规格" show-overflow-tooltip align="center"></el-table-column>
      <el-table-column prop="brandName" label="品牌" width="140" align="center"></el-table-column>
      <el-table-column prop="periodValidity" label="有效期(天)" width="100" align="center"></el-table-column>
      <el-table-column prop="packaging" label="主计量单位" width="100" align="center"></el-table-column>
      <el-table-column prop="pyMoney" label="标准价(￥)" width="100" align="center"></el-table-column>
      <el-table-column prop="membersPyMoney" label="会员价(￥)" width="100" align="center"></el-table-column>
      <el-table-column prop="productNumber" label="数量" width="120" align="center">
        <template slot-scope="scope">
          <el-input-number
            size="mini"
            v-model="scope.row.productNumber"
            @change="handleChange(scope.$index,scope.row)"
            :min="1"
          ></el-input-number>
        </template>
      </el-table-column>
      <el-table-column prop="endPyMoney" label="金额(￥)" align="center">
        <template slot-scope="scope">
          <span>{{scope.row.endPyMoney}}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="100">
        <template slot-scope="scope">
          <el-button
            class="delete-goods-btn"
            size="mini"
            type="text"
            @click="handleDelete(scope.$index, scope.row)"
          >删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- chen start -->
    <el-row class="sum-money-box">
      <el-col class="sum-money" :span="24" v-if="sumMoney==0">
        合计：
        <span class="sum-red">0</span>元
      </el-col>
      <el-col class="sum-money" :span="24" v-else>
        合计：
        <span class="sum-red">{{sumMoney.toFixed(2)}}</span>元
      </el-col>
    </el-row>
    <!-- end -->
    <div class="div-top-tip">
      商城目前有活动，
      <router-link class="table-tip-link" to></router-link>参与优惠的商品如下：
    </div>
    <div class="sale-table">
      <el-table
        class
        max-height="200"
        ref="multipleTable1"
        :data="saleTable"
        tooltip-effect="dark"
        empty-text="暂无优惠商品"
        style="width: 100%"
      >
        <el-table-column prop="orderNo" label="产品货号"></el-table-column>
        <el-table-column prop="promotionCode" label="促销码">
          <template slot-scope="scope">
            <span :id="'saleCode'+scope.row.id">{{scope.row.promotionCode}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="remark" label="描述"></el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import axios from "axios"; // 引入axios
var qs = require("qs");
import { post, get, postRequest, newpostRequest } from "@/axios/index";
export default {
  data() {
    return {
      //购物车商品数据
      goodsTable: [],
      //优惠信息表格
      saleTable: [],
      //选中的商品
      sumMoney: 0,
      input_number_value: 1,
      arrMoney: [],
      totalNum: 0,
      totalPrice: 1,
      pa: {},
      starTime: 0
    };
  },
  methods: {
    // 全选
    seletAll(val) {
      // console.log("val-----", val);
      this.selectChange(val, 2); //row为2代表全选
    },
    //选择单个商品
    selectChange(selection, row, index) {
      this.sumMoney = 0;
      if (row == 2) {
        //row为2代表全选
        // console.log("点击全选按钮");
        selection.forEach(ele => {
          ele.styl = true;
        });
      } else {
        row.styl = true;
      }
      this.arrMoney = selection;
      selection.forEach(ele => {
        if (ele.styl) {
          this.sumMoney += ele.productNumber * ele.membersPyMoney;
        }
      });
    },
    //结算
    confirmGoods() {
      let proId = [];
      this.arrMoney.forEach(ele => {
        proId.push(ele.id);
      });
      if (this.arrMoney.length == 0) {
        this.$message({
          type: "warning",
          message: "请先选择商品后再结算"
        });
      } else {
        let postData = this.$qs.stringify({
          ids: proId.toString()
        });
        this.userId = JSON.parse(localStorage.getItem("stkMessage")).id;
        post("/stkshoppingcenterinfo/getlistbyid", {
          ids: proId.toString(),
          userRegisterId: this.userId
        })
          .then(response => {
            console.log(
              "点击结算成功----------",
              response,
              response.data.result
            );
            if (response.data.code == 201) {
              this.$message({
                type: "error",
                message: response.data.msg
              });
            }
            if (response.data.code == 200) {
              let locPro = JSON.stringify(response.data.result);
              localStorage.setItem("loc", locPro);
              this.getProduct();
              this.$router.push({
                path: "/pc/order-confirm",
                query: {
                  userRegId: response.data.result[0].userRegisterId
                }
              });
            }
          })
          .catch(err => {
            console.log("261", err);
            this.$message({
              type: "error",
              message: err.message
            });
            console.log("添加失败err=", err);
          });
      }
    },
    //删除商品
    handleDelete(index, row) {
      this.$confirm("确认删除此商品?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true
      })
        .then(() => {
          console.log("删除row", row);
          this.userId = JSON.parse(localStorage.getItem("stkMessage")).id;
          // return
          get("/stkshoppingcenterinfo/delectbyid", {
            id: row.id,
            userRegisterId: this.userId,
            productId: row.productId
          }).then(
            response => {
              // console.log("response----------", response);
              if (response.data.code == 200) {
                this.$message({
                  type: "success",
                  message: "操作成功!"
                });
                this.getProduct();
                this.$forceUpdate();
                window.location.reload();
              } else {
                this.$message({
                  type: "warning",
                  message: response.data.data
                });
              }
            },
            err => {
              console.log(err);
            }
          );
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消操作"
          });
        });
    },

    //清空购物车
    clearGoods() {
      this.$confirm("确认清空购物车?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true
      })
        .then(() => {
          let arrId = [];
          this.goodsTable.forEach(ele => {
            arrId.push(ele.id);
          });
          this.userId = JSON.parse(localStorage.getItem("stkMessage")).id;
          console.log(this.userId);
          // return
          get("/stkshoppingcenterinfo/delectlistbyid", {
            ids: arrId.toString(),
            userRegisterId: this.userId
          }).then(
            response => {
              // console.log(response);
              if (response.data.code == 200) {
                // this.getProduct();
                this.$message({
                  type: "success",
                  message: "购物车已清空"
                });
                this.goodsTable = []; // 清除购物车本地缓存数据
                this.$router.push({
                  path: "/pc/product"
                });
              } else {
                this.$message({
                  type: "error",
                  message: response.data.data
                });
              }
            },
            err => {
              console.log(err);
            }
          );
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消操作"
          });
        });
    },
    handleChange(index, data) {
      console.log('1111111=========',index, data)
      // 1 清除set函数
      clearTimeout(this.timer);
      if (this.arrMoney.includes(data)) {
        this.arrMoney = this.arrMoney;
      }
      let pyMoney = data.productNumber * data.membersPyMoney;
      data.endPyMoney = pyMoney.toFixed(2);
      this.selectChange(this.arrMoney, data);
      this.timer = setTimeout(() => {
        this.changeProductNum(data.id, data.productNumber, data);
      }, 1000);
    },
    changeProductNum(id, number, item) {
      console.log("进入修改");
      postRequest("/stkshoppingcenterinfo/updatestkshoppingcenterinfo", {
        id: id,
        productNumber: number
      })
        .then(res => {})
        .catch(err => {
          console.log("修改结果err", err);
        });
    },
    getProduct() {
      get("/stkshoppingcenterinfo/getlistbystatusanduserid", {
        userRegisterId: this.userId
      })
        .then(res => {
          console.log("购物车列表res=", res.data.result);
          this.goodsTable = res.data.result;

          this.sumMoney = 0; //删除购物车商品时，重新请求商品列表，总价清空
        })
        .then(resu => {
          this.goodsTable.forEach(element => {
            element.styl = false;
            element.membersPyMoney = element.membersPyMoney.toFixed(2);
            element.endPyMoney = (element.productNumber * element.membersPyMoney).toFixed(2);
          });
          console.log(this.goodsTable, "---------------");
        });
    }
  },
  // created() {
  // },
  beforeMount() {
    this.goodsTable = [];
    if (JSON.parse(localStorage.getItem("stkMessage"))) {
      //判断用户是否已登录
      //获取用户id
      this.userId = JSON.parse(localStorage.getItem("stkMessage")).id;
      console.log(this.userId, "this.userId");
      //获取购物车商品
      this.getProduct();
      //获取促销商品
      get("/stkpromotioninfo/getlistbyuserid", {
        userRegisterId: this.userId
      }).then(res => {
        console.log("促销列表res------", res.data.result);
        this.saleTable = res.data.result;
        console.log(this.saleTable);
      });
    } else {
      //没有登录
      this.$router.push({ path: "/login" });
    }
  }
};
</script>

<style lang="less" scoped>
.top-btn-box {
  .common-content-width();
  margin-bottom: 26px;
  margin-top: 30px;
  .floatl {
    display: block;
    line-height: 48px;
    color: @common-blue;
  }
}

.agreement-box {
  .common-content-width();
  .common-shadow();
  padding-bottom: 26px;
  margin-bottom: 50px;
}

/deep/.register-input-box {
  padding: 31px;
  margin-bottom: 50px;
  .common-shadow();
  .common-content-width();
  margin-bottom: 50px;
  .el-input {
    width: 176px;
  }
  .el-form-item__label {
    font-size: 14px;
  }
  .el-form-item.is-required:not(.is-no-asterisk) > .el-form-item__label:before {
    color: #333;
  }
}

.dataform-input-box {
  line-height: 32px;
}

/deep/.goods-table {
  .common-content-width();
  // margin-bottom: 50px;
  .common-shadow();
  tr th:first-child {
    padding-left: 20px !important;
  }
  tr td:first-child {
    padding-left: 20px !important;
    .cell {
      color: #666 !important;
    }
  }
  tr td:nth-last-child(4),
  tr td:nth-last-child(3) {
    .cell {
      color: @color-orange !important;
    }
  }
}

/deep/.sale-table {
  .common-shadow();
  .common-content-width();
  margin-bottom: 50px;
  tr th:first-child div {
    padding-left: 0 !important;
  }
  tr td:first-child div {
    padding-left: 0 !important;
  }
  .el-button {
    width: 64px;
    height: 24px;
    border-radius: 2px;
    border: solid 1px #999999;
    padding: 0;
    font-size: 14px;
    margin-right: 40px;
  }
}

.sale-table {
  background: #fff;
  padding: 30px;
}

.table-tip-link {
  color: @common-blue;
}

/deep/.sale-table-handle {
  color: @common-blue;
  margin-top: 20px;
  .el-input {
    width: 248px;
  }
  .el-input__inner {
    height: 32px;
  }
  .el-icon-info:before {
    margin: 0 10px 0 30px;
  }
}

.agreement-img {
  display: block;
  width: 150px;
  height: 200px;
  margin: 23px auto;
}

.agreement-btn {
  margin: 0 auto;
  display: block;
}

.el-input-number--mini {
  width: 100px;
}

.delete-goods-btn {
  color: @color-red !important;
}
.delete-goods-btn:hover {
  color: @color-red !important;
}

/deep/.el-input-number__decrease {
  border-radius: 8px 0 0 8px !important;
}

/deep/.el-input-number__increase {
  border-radius: 0 8px 8px 0 !important;
}

.handle-sum {
}

/deep/.el-input-number__decrease {
  // background: transparent;
  // top: 0;
  // left: 0;
}

// 合计
.sum-money-box {
  height: 60px;
  line-height: 60px;
  margin: 0 auto 60px;
  background: rgb(230, 230, 230);
  width: 1000px;
  .sum-money {
    padding-left: 80%;
    .sum-red {
      color: #ff5f5f !important;
    }
  }
}
@import "./style/main";
</style>



// WEBPACK FOOTER //
// src/components/pages/order/OrderCart.vue